import React, { useState, useCallback } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmailIcon from "@material-ui/icons/Email";
import TextField from "@material-ui/core/TextField";

import { fetchAsyncPasswordReset } from "./authSlice";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100vh",
  },
  paperAfter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 2,
    borderRadius: 10,
    width: "90%",
    padding: "60px 20px",
    background: "rgba(51,102,153,0.4)",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  white: {
    color: "#ffffff",
    fontWeight: "bold",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  mailDone: {},
  form: {
    width: "80%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    zIndex: 1,
    color: "#ffffff",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#2699FB",
  },
  error: {
    margin: theme.spacing(3, 0),
    color: "#cc3333",
    fontSize: 12,
  },
  passError: {
    fontSize: 12,
    width: "100%",
    color: "#f44336",
  },
  subText: {
    fontSize: 12,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    lineHeight: 2,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2),
  },
  headerBack: {
    paddingLeft: theme.spacing(3),
  },
  hero: {
    backgroundImage: "url(https://source.unsplash.com/AwmCuTXL97Q)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100%",
    position: "absolute",
    width: "100%",
    zIndex: 0,
  },
  text: {
    color: "#ffffff",
    fontWeight: "bold",
  },
  circulContainer: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    zIndex: 3,
  },
  circul: {
    height: "100px !important",
    width: "100px !important",
  },
}));

const PasswordReset = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [emailValue, setEmailValue] = useState({ email: "" });
  const [isEmailSend, setIsEmailSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const backProfile = useCallback(() => {
    setIsEmailSend(false);
    setEmailValue({ email: "" });
    history.goBack();
  }, [history, dispatch]);
  //送信ボタン
  //送れて送れなくてもメール送信完了を表示
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    await dispatch(fetchAsyncPasswordReset(emailValue));
    setIsLoading(false);
    setIsEmailSend(true);
  };

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    let str = e.target.value;

    str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    str = str.replace(/[^!-~]/g, "");

    await setEmailValue({ email: str });
  };
  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        {isLoading && (
          <div className={classes.circulContainer}>
            <CircularProgress className={classes.circul} />
          </div>
        )}
        <div className={classes.header}>
          <div className={classes.headerBack}>
            {isEmailSend || <ArrowBackIcon onClick={backProfile} />}
          </div>
        </div>

        {isEmailSend === true ? (
          <div>
            <div className={classes.hero}></div>
            <div className={classes.paperAfter}>
              <Typography component="h1" variant="h5" className={classes.text}>
                パスワードリセット
              </Typography>
              <Typography className={classes.subText + " " + classes.white}>
                入力されたメールアドレスに
                <br />
                パスワードリセットメールを送信しました。
                <br />
                記載されたリンクより手続きをお願いします。
              </Typography>
            </div>
          </div>
        ) : (
          <div className={classes.paper}>
            <Typography component="h1" variant="h5">
              パスワードリセット
            </Typography>

            <Typography className={classes.subText}>
              入力されたメールアドレスに
              <br />
              パスワードリセットメールを送信します。
            </Typography>
            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                margin="normal"
                fullWidth
                required
                id="email"
                label="メールアドレス"
                name="email"
                type="email"
                autoComplete="email"
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
                value={emailValue.email}
                onChange={handleInputChange}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                メールを送信する
              </Button>
            </form>
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default PasswordReset;
